import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import NotificationSystem from 'react-notification-system';
import {Link} from 'react-router-dom';
import axios from 'axios';

import validators from '../../utils/validators';
import urls from '../../utils/urls';


class ForgotPassword extends Component {

    constructor(props){
        super(props);

        this.state = {
            email: '',
            initial: true,
            invalid_email: false,
            recovery_error: false,
            _notificationSystem: null
        }
    }

    componentDidMount(){
        this.setState({_notificationSystem: this.refs.notificationSystem});
    }

    _handleInputEmail = (ev) => {
        this.setState({email: ev.target.value.toLowerCase()});
    };

    _handleSubmit = (ev) => {
        ev.preventDefault();

        if(this.state.email === '' || !(validators.email(this.state.email))){
            // Email is empty or email is not valid
            if (!(this.state.invalid_email)) {
                // Checking if the alert is already displayed
                this.setState({invalid_email: true});
                this.state._notificationSystem.addNotification({
                    title: 'Email inválido',
                    message: 'Por favor, ingrese una dirección de correo válida.',
                    level: 'error',
                    position: 'bc',
                    dismissible: false,
                    onRemove: () => {
                        this.setState({invalid_email: false});
                    }
                });
            }
            return false;
        }

        let button = ev.target;
        button.classList.add("disabled");

        const reset_url = `${urls.API_ROOT}/api/v1/password/recover/`;
        axios.post(reset_url, {email: this.state.email}, {})
            .then(() => this.setState({initial: false}))
            .catch(() => {
                if (!(this.state.recovery_error)) {
                    this.setState({recovery_error: true});
                    this.state._notificationSystem.addNotification({
                        title: 'Error en el recupero de contraseña',
                        message: 'Ha ocurrido un error en la comunicación con el servidor. Por favor, verifique su conexión y vuelva a intentarlo',
                        level: 'error',
                        position: 'bc',
                        dismissible: false,
                        onRemove: () => {
                            this.setState({recovery_error: false});
                        }
                    });
                }
                button.classList.remove("disabled");
            });
    };

    render() {

        let body = '';
        if (this.state.initial) {
            body = (
                <div>
                    <div className={'row'}>
                        <p className="text-left shell-lightgrey-text padding-10" style={{fontSize: 16}}>¿Ha olvidado su
                            clave?
                            <br/>
                            Introduzca su dirección de correo a continuación y le enviaremos por correo
                            electrónico las instrucciones para establecer una nueva.</p>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input value={this.state.email} type="text" placeholder="Ingrese su email"
                                   onChange={this._handleInputEmail}/>
                            <label className="active"> Email</label>
                        </div>
                        <div className="input-field col s12">
                            <button type="submit" ref="loginButton"
                                    className={"btn btn-yellow z-depth-0 margin-bottom-10"}
                                    onClick={this._handleSubmit}>Continuar
                            </button>
                        </div>
                    </div>
                </div>)
        } else {
            body = (
                <div>
                    <div className={'row text-left'}>
                        <img style={{height: '75px', marginLeft: '-30px'}} className={"responsive-img"}
                             src="/static/images/paperplane.png" alt="Shell"/>
                    </div>
                    <div className={'row'}>
                        <p className="text-left shell-lightgrey-text padding-10" style={{fontSize: 16}}>Le hemos enviado
                            por email las instrucciones para restablecer la contraseña, si es que existe una cuenta con
                            la dirección electrónica que indicó.</p>
                    </div>
                    <div className={'row'}>
                        <p className="text-left shell-lightgrey-text padding-10" style={{fontSize: 12}}>Si no recibe un
                            correo,
                            por favor asegúrese de haber ingresado la dirección de correo correcta y verifique su
                            carpeta de spam.</p>
                    </div>
                </div>
            );
        }


        return (
            <div>
                <div className="valign-wrapper main-login">
                    <div className="login-container text-center">
                        <div className="form-login">
                            <form>
                                <h4 className="text-center bold" style={{fontSize: 30}}>Recupero de
                                    contraseña</h4>
                                {body}
                                <div>
                                    <Link to='/' className="text-center shell-red-text" style={{fontSize: 16}}>
                                        Volver al inicio</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem"/>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/forgotPassword.js